//#region src/utils/analytics/autoTracking.ts
var e = [
	"data-track-ga-event-trigger",
	"data-track-ga-event-category",
	"data-track-ga-event-action",
	"data-track-ga-event-label",
	"data-track-ga-event-value"
], t = (t) => e.some((e) => t[e] !== void 0), n = (e) => {
	let { autoTrackingKey: n, props: r, source: i = "element", trigger: a = "click", category: o, action: s } = e, c = o || `${i} autoTracking`, l = s || `${i} ${a}`;
	return t(r) || !n || n.trim() === "" ? {} : {
		"data-track-ga-event-trigger": a,
		"data-track-ga-event-category": c,
		"data-track-ga-event-action": l,
		"data-track-ga-event-label": n
	};
};
//#endregion
export { n as getAutoTrackingAttributes };

//# sourceMappingURL=autoTracking.js.map